<template>
  <AppHeader>View Customer</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">

    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <p class="text-xl text-gray-900">{{ data.customer.name }} <small>(#{{ data.customer.id }})</small></p>
      <p class="mt-1 text-xl"><b>{{ toInr(data.customer.wallet_balance) }}</b></p>
      <p class="mt-2 text-lg"><a @click="initiateCall(data.customer.phone)"><b>{{ data.customer.phone }}</b></a></p>
      <p class="mt-2"><b>{{ data.subscriptions.length }} Subscription(s)</b></p>
      <p class="mt-2"><b>{{ data.customer.address }}</b></p>
      <p class="mt-3 text-xl"><b>{{ data.customer.tags ? data.customer.tags.join(', ') : '' }}</b></p>

      <div class="mt-3">
        <select v-model="form.group_id" class="px-2 rounded" @change="updateGroup()">
          <option v-for="group in data.groups" :key="group.id" :value="group.id">{{ group.name }}</option>
        </select>
      </div>

      <div class="flex items-center justify-start mt-4 text-gray-700 gap-x-2">
        <router-link class="px-3 py-1 text-sm leading-none rounded-full bg-slate-300" :to="{name: 'CreateTransaction', query: {customer_id: data.customer.id}}"><i class="ion-md-add"></i> TNX</router-link>
        <router-link class="px-3 py-1 text-sm leading-none rounded-full bg-slate-300" :to="{name: 'CreateSubscription', query: {customer_id: data.customer.id}}"><i class="ion-md-add"></i> SUB</router-link>
        <router-link class="px-3 py-1 text-sm leading-none rounded-full bg-slate-300" :to="{name: 'CreateVacation', query: {customer_id: data.customer.id}}"><i class="ion-md-add"></i> VAC</router-link>
        <router-link class="px-3 py-1 text-sm leading-none bg-green-300 rounded-full" :to="{name: 'CustomerMapLocation', params: {id: data.customer.id}}"><i class="ion-md-pin"></i> MAP</router-link>
        <button class="px-3 py-1 text-sm leading-none bg-red-300 rounded-full" @click="deactivate()"><i class="ion-md-trash"></i></button>
      </div>
      <!-- <div class="flex items-center justify-start mt-3 text-gray-700 gap-x-2">
        <a class="px-3 py-1 text-sm leading-none bg-blue-300 rounded-full" v-if="data.customer.house_image" :href="data.customer.house_image.src" target="_system" title="View House Image"><i class="ion-md-image"></i></a>
        <button class="px-3 py-1 text-sm leading-none bg-blue-300 rounded-full" @click="$refs.uploader.click()"><i class="ion-md-cloud-upload" title="Upload House Image"></i></button>
        <input type="file" class="hidden" ref="uploader" @change="uploadImage">
      </div> -->

      <div class="flex items-center justify-start mt-3 text-gray-700 gap-x-2"> 
        <div class="flex gap-2 px-1 py-1 text-sm leading-none rounded-full bg-white border"> 
          <p class="text-sm text-gray-500 px-3 py-1">House</p> 
          <a class="text-sm leading-none bg-slate-300 rounded-full px-3 py-1" v-if="data.customer.house_image" :href="data.customer.house_image.src" target="_system" title="View House Image">
            <i class="ion-md-image"></i>
          </a> 
          <button class="text-sm leading-none bg-slate-300 rounded-full px-3 py-1" @click="$refs.house_image.click()">
              <i class="ion-md-cloud-upload" title="Upload House Image"></i>
            </button> <input type="file" class="hidden" ref="house_image" @change="e => uploadImage(e, 'house')"> 
        </div> 
        <div class="flex gap-2 p-1 text-sm leading-none rounded-full bg-white border">
          <p class="text-sm text-gray-500 px-3 py-1">Dropoff</p> 
          <a class="text-sm leading-none bg-slate-300 rounded-full px-3 py-1" v-if="data.customer.dropoff_point" :href="data.customer.dropoff_point.src" target="_system" title="View Dropoff Image">
            <i class="ion-md-image"></i>
          </a> 
          <button class="text-sm leading-none bg-slate-300 rounded-full px-3 py-1" @click="$refs.dropoff.click()">
            <i class="ion-md-cloud-upload" title="Upload Dropoff Image"></i>
          </button> 
          <input type="file" class="hidden" ref="dropoff" @change="e => uploadImage(e, 'dropoff')"> 
        </div> 
      </div>
    </div>

    <p v-if="checkSettings()" class="mt-5 text-lg text-gray-500">Preferences</p>
    <div v-if="checkSettings()" class="p-3 mt-2 text-lg text-gray-500 bg-white shadow rounded-2xl">
      <div v-if="data.customer.settings.communication_time" class="flex justify-between">
        <p>Communication Time</p>
        <p>{{ data.customer.settings.communication_time }}</p>
      </div>
      <div v-if="data.customer.settings.communication_method" class="flex justify-between mt-2">
        <p>Communication Method</p>
        <p>{{ data.customer.settings.communication_method }}</p>
      </div>
      <div v-if="data.customer.settings.milk_delivery_time" class="flex justify-between mt-2">
        <p>Milk Delivery Time</p>
        <p>{{ data.customer.settings.milk_delivery_time }}</p>
      </div>
      <div v-if="data.customer.settings.use_calling_bell" class="flex justify-between mt-2">
        <p>Use Calling bell</p>
        <p>{{ data.customer.settings.use_calling_bell }}</p>
      </div>
    </div>

    <div class="flex items-center justify-between mt-5">
      <p class="text-lg text-gray-500">Subscriptions</p>
      <button class="text-sm text-gray-700" @click="showActiveSubs = !showActiveSubs">Toggle {{ showActiveSubs ? 'All' : 'Active' }}</button>
    </div>
    <div class="mt-2 responsive-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Product</th>
            <th>Repeat</th>
            <th>QTY</th>
            <th>Start</th>
            <th>End</th>
            <th>Days</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="sub in subscriptions" :key="sub.id">
            <td>#{{ sub.id }}</td>
            <td><router-link :to="'/subscriptions/' + sub.id"><b>{{ sub.product.name }} ({{ sub.product.quantity }})</b></router-link></td>
            <td>{{ sub.type }}</td>
            <td><b>{{ sub.quantity }}</b></td>
            <td>{{ toDate(sub.start_date) }}</td>
            <td>{{ sub.end_date ? toDate(sub.end_date) : 'NONE' }}</td>
            <td>{{ diffBetweenDates(sub.start_date, sub.end_date) }}</td>
            <td>{{ sub.status }}</td>
            <td class="text-gray-700">
              <button v-if="sub.status == 'active'" @click="updateSub(sub.id, 'pause')" class="px-3 py-1 text-sm leading-none rounded-full bg-amber-300">Pause</button>
              <button v-if="sub.status == 'created' || sub.status == 'active'" @click="updateSub(sub.id, 'cancel')" class="px-3 py-1 text-sm leading-none bg-red-300 rounded-full">Cancel</button>
              <button v-if="sub.status == 'dealer-paused'" @click="updateSub(sub.id, 'active')" class="px-3 py-1 text-sm leading-none bg-green-300 rounded-full">Activate</button>
            </td>
          </tr>
          <tr v-if="subscriptions.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No {{ showActiveSubs ? 'Active' : 'Past' }} Subscriptions</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex items-center justify-between mt-5">
      <p class="text-lg text-gray-500">Vacations</p>
      <button class="text-sm text-gray-700" @click="showActiveVacs = !showActiveVacs">Toggle {{ showActiveVacs ? 'All' : 'Active' }}</button>
    </div>
    <div class="mt-2 responsive-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Created On</th>
            <th>Date</th>
            <th>Days</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="vac in vacations" :key="vac.id">
            <td>#{{ vac.id }}</td>
            <td>{{ toDate(vac.created_at, true) }}</td>
            <td>{{ toDate(vac.start_date) }} <i class="ion-md-arrow-forward"></i> {{ toDate(vac.end_date) }}</td>
            <td>{{ diffBetweenDates(vac.start_date, vac.end_date) }}</td>
            <td>{{ vac.status }}</td>
            <td class="text-gray-700">
              <button v-if="vac.status == 'created' || vac.status == 'active'" @click="cancelVacation(vac.id)" class="px-3 py-1 text-sm leading-none bg-red-300 rounded-full">Cancel</button>
            </td>
          </tr>
          <tr v-if="vacations.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No {{ showActiveVacs ? 'Active' : 'Past' }} Vacations</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="mt-5 text-lg text-gray-500">Transactions</p>
    <div class="mt-2 responsive-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Purpose</th>
            <th>Balance</th>
          </tr>
        </thead>

        <tbody>
          <tr :class="{ 'bg-green-300': t.type == 'credit', 'bg-red-300': t.type == 'debit' }" v-for="t in data.transactions" :key="t.id">
            <td>#{{ t.id }}</td>
            <td>{{ toDate(t.date) }}</td>
            <td>{{ toInr(t.amount) }}</td>
            <td>{{ t.purpose }}</td>
            <td>{{ toInr(t.closing_balance) }}</td>
          </tr>
          <tr v-if="data.transactions.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No Transactions</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'ViewCustomer',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      data: {},
      form: { group_id: null, delivery_quantity: null, delivery_fee: null },
      subscriptions: [],
      vacations: [],
      showActiveSubs: true,
      showActiveVacs: true,
      showDeliveryFeeChanger: false,
      selectedFile: null,
    }
  },

  watch: {
    showActiveSubs(toggle) {
      if (toggle) this.subscriptions = this.data.subscriptions.filter((sub) => (sub.status == 'active' || sub.status == 'created' || sub.status == 'paused' || sub.status == 'dealer-paused'));
      else this.subscriptions = this.data.subscriptions;
    },

    showActiveVacs(toggle) {
      if (toggle) this.vacations = this.data.vacations.filter((vac) => (vac.status == 'active' || vac.status == 'created'));
      else this.vacations = this.data.vacations;
    },
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'customers/' + this.$route.params.id, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
          this.subscriptions = this.data.subscriptions.filter((sub) => (sub.status == 'active' || sub.status == 'created' || sub.status == 'paused' || sub.status == 'dealer-paused'));
          this.vacations = this.data.vacations.filter((vac) => (vac.status == 'active' || vac.status == 'created'));
          this.form.group_id = resp.data.customer.group_id;
          this.form.delivery_quantity = resp.data.customer.delivery_quantity;
        }
      });
    },

    cancelVacation(id) {
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';

      this.request('GET', 'vacations/' + id + '/cancel', {}, (resp) => {
        this.isLoading = false
        alert(resp.message)
        if (resp.success) {
          this.vacations.forEach((i, ind) => {
            if (i.id == id) this.vacations[ind].status = 'cancelled';
          });
        }
      });
    },

    updateSub(id, status) {
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';

      this.request('GET', 'subscriptions/' + id + '/' + status, {}, (resp) => {
        this.state = 'idle';
        alert(resp.message);
        if (resp.success) this.getData();
      });
    },

    deactivate() {
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';

      this.request('GET', 'customers/' + this.data.customer.id + '/deactivate', {}, (resp) => {
        alert(resp.message)
        if (resp.success) this.$router.go(-1);
      });
    },

    updateGroup() {
      if (!confirm('Are you sure?')) {
        this.form.group_id = this.data.customer.group_id;
        return;
      }

      this.state = 'loading';

      this.request('POST', 'customers/' + this.data.customer.id + '/group', {group_id: this.form.group_id}, (resp) => {
        this.state = 'idle';
        alert(resp.message);
        if (resp.success) this.getData();
      });
    },

    updateDeliveryFee() {
      if (!confirm('Are you sure?')) {
        this.form.delivery_quantity = this.data.customer.delivery_quantity;
        this.form.delivery_fee = this.data.deliveryFeeStructure[this.form.delivery_quantity];
        return;
      }

      this.state = 'loading';

      this.form.delivery_fee = this.data.deliveryFeeStructure[this.form.delivery_quantity];

      this.request('POST', 'customers/' + this.data.customer.id + '/delivery-fee', {delivery_quantity: this.form.delivery_quantity, delivery_fee: this.form.delivery_fee}, (resp) => {
        this.state = 'idle';
        alert(resp.message);
        if (resp.success) this.getData();
      });
    },

    checkSettings() {
      return this.data.customer.settings.communication_time
              || this.data.customer.settings.communication_method
              || this.data.customer.settings.milk_delivery_time
              || this.data.customer.settings.use_calling_bell;
    },

    uploadImage(e , type) {
      const file = e.target.files[0];
      const formData = new FormData();
      if (type === 'house') {
        formData.append('house_image', file);
      } else {
        formData.append('dropoff_point', file);
      }
      this.request('POST', 'customers/' + this.data.customer.id +'/images', formData, (resp) => {
          this.state = 'idle';

          alert(resp.message ? resp.message : 'Unable to send image, try again!');
          if (resp.success) {
            this.selectedFile = null;
            this.getData();
          }
        });
    },
  },

  created() {
    if (!this.$route.params.id) this.$router.go(-1);
    else this.getData();
  }
}
</script>
